/**
 * Keycloak session + investment office persistence in localStorage.
 * `AUTH_SESSION_STORAGE_KEYS` is exported for consumers that need raw keys (e.g. `src/core/api`).
 */
export const AUTH_SESSION_STORAGE_KEYS = {
  investmentOfficeId: 'wt_investment_office_id',
  apiToken: 'wt_api_token',
  apiRefreshToken: 'wt_api_refresh_token',
} as const;

export type AuthSessionCredentials = {
  accessToken: string;
  refreshToken: string;
  investmentOfficeId: string;
};

export const getAuthAccessToken = (): string | null =>
  localStorage.getItem(AUTH_SESSION_STORAGE_KEYS.apiToken);

export const getAuthRefreshToken = (): string | null =>
  localStorage.getItem(AUTH_SESSION_STORAGE_KEYS.apiRefreshToken);

export const getStoredInvestmentOfficeId = (): string | null =>
  localStorage.getItem(AUTH_SESSION_STORAGE_KEYS.investmentOfficeId);

/** Persiste solo el despacho (p. ej. alta pública antes de una petición). */
export const setStoredInvestmentOfficeId = (investmentOfficeId: string): void => {
  localStorage.setItem(
    AUTH_SESSION_STORAGE_KEYS.investmentOfficeId,
    investmentOfficeId,
  );
};

/** Quita solo la oficina persistida (tokens intactos). */
export const clearStoredInvestmentOfficeId = (): void => {
  localStorage.removeItem(AUTH_SESSION_STORAGE_KEYS.investmentOfficeId);
};

export const persistAuthSessionCredentials = ({
  accessToken,
  refreshToken,
  investmentOfficeId,
}: AuthSessionCredentials): void => {
  localStorage.setItem(AUTH_SESSION_STORAGE_KEYS.apiToken, accessToken);
  localStorage.setItem(
    AUTH_SESSION_STORAGE_KEYS.apiRefreshToken,
    refreshToken,
  );
  localStorage.setItem(
    AUTH_SESSION_STORAGE_KEYS.investmentOfficeId,
    investmentOfficeId,
  );
};

export const setStoredRefreshToken = (refreshToken: string): void => {
  localStorage.setItem(
    AUTH_SESSION_STORAGE_KEYS.apiRefreshToken,
    refreshToken,
  );
};

/** Clears all three auth-related localStorage entries (session end / invalidation). */
export const clearAuthSessionStorage = (): void => {
  localStorage.removeItem(AUTH_SESSION_STORAGE_KEYS.apiToken);
  localStorage.removeItem(AUTH_SESSION_STORAGE_KEYS.apiRefreshToken);
  localStorage.removeItem(AUTH_SESSION_STORAGE_KEYS.investmentOfficeId);
};
